"use strict";
function waitFor(element, eventName) {
    return new Promise(function(resolve) {
        function handler() {
            element.removeEventListener(eventName, handler);
            var msg = "It was ".concat(eventName, " on the element: ").concat(element.nodeName, ", id: ").concat(element.id, ".");
            resolve(msg);
        }
        element.addEventListener(eventName, handler);
    });
}
var printMessage = function(message) {
    var msgDiv = document.createElement("div");
    msgDiv.className = "message";
    msgDiv.textContent = message;
    document.body.appendChild(msgDiv);
};
var loginField = document.getElementById("login");
var passwordField = document.getElementById("password");
var button = document.getElementById("submit");
waitFor(loginField, "click").then(printMessage);
waitFor(passwordField, "click").then(printMessage);
waitFor(button, "click").then(printMessage);
waitFor(loginField, "input").then(printMessage);
waitFor(passwordField, "input").then(printMessage);
waitFor(loginField, "blur").then(printMessage);
waitFor(passwordField, "blur").then(printMessage);
waitFor(button, "blur").then(printMessage);
window.waitFor = waitFor;
window.printMessage = printMessage;

//# sourceMappingURL=index.813ad2e1.js.map
